import React from 'react';
import { FiCheck } from 'react-icons/fi';

const STEPS = ['Panel', 'Details', 'Collection', 'Lab questions', 'Pay'];

export default function LabCheckoutProgress({ current }) {
  return (
    <div className="lcw-progress">
      {STEPS.map((label, i) => {
        const stepNum = i + 1;
        const done = current > stepNum;
        const active = current === stepNum;

        let circleClass = 'lcw-circle-upcoming';
        if (done) circleClass = 'lcw-circle-done';
        else if (active) circleClass = 'lcw-circle-active';

        return (
          <React.Fragment key={label}>
            <div className="lcw-progress-step">
              <div className={`lcw-progress-circle ${circleClass}`}>
                {done ? <FiCheck size={15} strokeWidth={2.5} /> : stepNum}
              </div>
              <span className={`lcw-progress-label ${active ? 'lcw-progress-label--active' : ''} ${done ? 'lcw-progress-label--done' : ''}`}>
                {label}
              </span>
            </div>
            {i < STEPS.length - 1 && (
              <div className={`lcw-progress-connector ${done ? 'lcw-progress-connector--done' : ''}`} />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}
